<section class="w-50 mx-auto my-5 text-center">
  <h1>Welcome To The Much Smarter Admin</h1>
</section>
